import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { RestService } from '../services/rest.service';
import { Alert } from '../shared/alert/alert.class';
import { _global } from '@angular/localize/src/localize';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  alert = new Alert();

  @ViewChild('modal_update') modal_update: ElementRef;
  @ViewChild('modal_change_password') modal_change_password: ElementRef;

  current_user = null;
  current_user_permission = null;

  form_update: FormGroup;
  form_update_password: FormGroup;
  form_update_password_info: String = null;

  constructor(private restService: RestService, private modalService: NgbModal, private builder: FormBuilder) { }

  ngOnInit() {
    this.user_read_one();

    this.form_update = this.builder.group({
      id: [null, Validators.required],
      fullname: [null, Validators.required],
      email: [null, Validators.required]
    });

    this.form_update_password = this.builder.group({
      id: [null, Validators.required],
      password_current: [null, Validators.required],
      password: [null, Validators.required],
      password_validate: [null, Validators.required]
    });
  }

  user_read_one() {
    this.restService.user_read_one({}).subscribe(data => {
      if (data.success) {
        this.current_user = data.record;
        this.rol_read_config();
      } else {
        this.current_user = null;
      }
    }, err => {
      this.current_user = null;
    });
  }

  rol_read_config() {
    this.restService.rol_read_config({ idrol: this.current_user.idrol }).subscribe(data => {
      if (data.success) {
        this.current_user_permission = data.records;
      }
    }, err => {
      this.current_user_permission = null;
    });
  }

  user_update(_data) {
    this.restService.user_update(_data).subscribe(data => {
      if (data.success) {
        this.user_read_one();
        this.alert.set_success("Registro actualizado.");
      } else {
        this.alert.set_warning("Registro no actualizado.");
      }
    }, err => {
      this.alert.set_danger("Registro no actualizado.");
    });
  }

  update(): void {
    this.form_update.controls['id'].setValue(this.current_user.id);
    this.form_update.controls['fullname'].setValue(this.current_user.fullname);
    this.form_update.controls['email'].setValue(this.current_user.email);
    this.open_modal_update();
  }

  submit_form_update(): void {
    if (this.form_update.valid) {
      if (this.form_update.value.id) {//update
        this.user_update(this.form_update.value);
      }
    }
  }

  reset_form_update(): void {
    this.form_update.reset();
  }

  open_modal_update() {
    this.modalService.open(this.modal_update, { size: 'md' }).result.then((result) => {
      if (result == 'send') {
        this.submit_form_update();
      }
      this.reset_form_update();
    }, (reason) => {
      this.reset_form_update();
    });
  }

  submit_form_update_password(): void {
    if (this.form_update_password.valid) {
      this.login_validate(this.form_update_password.value.password_current);
      /* if (this.form_update_password.value.password === this.form_update_password.value.password_validate) {
        this.user_update_password(this.form_update_password.value);
        this.modalService.dismissAll();
      } else {
        this.form_update_password_info = "Las contraseñas deben ser iguales.";
      } */
    }
  }

  change_password_field(): void {
    this.form_update_password_info = null;
  }

  login_validate(_password) {
    const data = {
      user: this.current_user.id,
      password: _password
    };
    this.restService.login_validate(data).subscribe(data => {
      if (data.success) {
        if (this.form_update_password.value.password === this.form_update_password.value.password_validate) {
          this.user_update_password(this.form_update_password.value);
          this.modalService.dismissAll();
        } else {
          this.form_update_password_info = "Las contraseñas deben ser iguales.";
        }
      } else {
        this.form_update_password_info = "La contraseña actual no es correcta.";
      }
    }, (reason) => {
      this.form_update_password_info = "Hubo problemas al obtener la información, intenta mas tarde.";
    });
  }

  user_update_password(_data) {
    this.restService.user_update(_data).subscribe(data => {
      if (data.success) {
        this.alert.set_success("Contraseña actualizada.");
      } else {
        this.alert.set_warning("Contraseña no actualizada.");
      }
    }, err => {
      this.alert.set_danger("Contraseña no actualizada.");
    });
  }

  reset_form_update_password(): void {
    this.form_update_password.reset();
    this.form_update_password_info = null;
    this.form_update_password.controls['id'].setValue(this.current_user.id);
  }

  update_password(): void {
    this.form_update_password.controls['id'].setValue(this.current_user.id);
    this.open_modal_update_password();
  }

  open_modal_update_password() {
    this.modalService.open(this.modal_change_password, { size: 'md' }).result.then((result) => {
      if (result == 'send') {
        //this.submit_form_update();
      }
      this.reset_form_update_password();
    }, (reason) => {
      this.reset_form_update_password();
    });
  }

  get_initial(_value: string): string {
    if (_value && _value.length > 0) return _value.substring(0, 1);
    else return "!";
  }

}
